module.exports = __webpack_public_path__ + "media/assets/great-story-d4010032de1d2c01ff2f84f430023c20.svg";